export default "__VITE_ASSET__ad108143__"